// Publishes the current player's color palette as CSS custom properties.

import { useMemo, type CSSProperties } from 'react';
import { useRoomMyPlayer } from './useRoomMyPlayer';
import { resolvePlayerPalette } from '../styles/playerColors';

export type PlayerColorStyle = CSSProperties & {
  '--player-color-light': string;
  '--player-color-base': string;
  '--player-color-dark': string;
};

export function usePlayerColorStyle(): PlayerColorStyle {
  const myPlayer = useRoomMyPlayer();

  return useMemo(() => {
    const { palette } = resolvePlayerPalette(myPlayer);

    return {
      '--player-color-light': palette.light,
      '--player-color-base': palette.base,
      '--player-color-dark': palette.dark,
    } as PlayerColorStyle;
  }, [myPlayer]);
}
